import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Button } from '@mui/material';
import useAuthNavigation from '../../view/authentication/useAuthNavigation';
import { H2, Body1 } from '../../themes/typography';
import '../../styles/components/AboutEvent.css';

export default function AboutEvent() {

    const navigate = useNavigate();
    const { openAuth } = useAuthNavigation();

    const { isLoggedIn, user } = useSelector((state) => state.auth);

    const handleCreateEventClick = (e) => {
        e.preventDefault();

        if (isLoggedIn && user?.id) {
            navigate('/event/new/event-details');
        } else {
            openAuth();
        }
    };

    return (
        <div className="about-event-container">
            <div className="about-event-title-section">
                <H2 color="#11203A">Got an Event?</H2>
            </div>
            <div className="about-event-description-section">
                <Body1 color="#11203A">
                    Get the word out with Surat's very own discovery platform for events, outings &
                    activities
                </Body1>
            </div>
            <div className="about-event-button-section">
                <Button onClick={handleCreateEventClick} variant="main">
                    Create Event
                </Button>
            </div>
        </div>
    );
}
